import { getMaster } from "utils/api"

export const queryDropdownOptions = async () => {
  return await getMaster("/dropdown-options");
};